import { render, staticRenderFns } from "./form-tbzt.vue?vue&type=template&id=4bbd1ccd&scoped=true&"
import script from "./form-tbzt.vue?vue&type=script&lang=js&"
export * from "./form-tbzt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbd1ccd",
  null
  
)

export default component.exports